import { Head } from 'arcway/lib/client';
import { LegalDocument } from '#components/legal-document.jsx';
export default function TermsPage({
  document
}) {
  return <>
      <Head description='The terms governing use of mono.fm and its services.' title='Terms of Service — mono.fm' />
      <LegalDocument document={document} otherHref='/legal/privacy' otherTitle='Privacy Policy' />
    </>;
}